import { TInfrastructureParamName, TInfrastructureParams } from '../../../components/advanced/params/infrastructure';
import { ensureSingleTagExists, ensureTagNotExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IInfrastructureParamTagType = 'advanced-infrastructure';

export interface IInfrastructureParamTag {
  type: 'advanced-infrastructure';
  paramName: TInfrastructureParamName;
}

const isInfrastructureParamTag = (tag: TTag): tag is IInfrastructureParamTag =>
  tag.type === IInfrastructureParamTagType;

export const infrastructureParamsTagDefinition = Object.keys(TInfrastructureParams).map(key =>
  createInfrastructureParamTag(TInfrastructureParams[key].jqParamName),
);

function createInfrastructureParamTag(paramName: TInfrastructureParamName): ITagDefinition {
  return {
    reduce: (tags, jsonQuery) => {
      // tslint:disable-next-line:no-any
      const value: boolean | undefined = (jsonQuery as any)[paramName] && (jsonQuery as any)[paramName].value;

      if (value) {
        return ensureSingleTagExists(
          tags,
          (tag: TTag): tag is IInfrastructureParamTag => isInfrastructureParamTag(tag) && tag.paramName === paramName,
          previousTag => ({ type: IInfrastructureParamTagType, paramName }),
        );
      } else {
        return ensureTagNotExists(
          tags,
          (tag: TTag): tag is IInfrastructureParamTag => isInfrastructureParamTag(tag) && tag.paramName === paramName,
        );
      }
    },
  };
}
